import { Backdrop, CircularProgress } from "@mui/material";
import { Button, Col, Popconfirm, Row, Table, TableProps, Typography } from "antd";
import { useEffect, useState } from "react";
import AdminLayout from "../../../component/AdminLayout";
import { customSortDirections } from "../../../Utils/utils";
import {

  EyeOutlined
} from "@ant-design/icons";
import RejectReason from "../components/rejectreason";
import TaskDetails from "../../pendingTasks/components/TaskDetails";
import { ApprovalEmailLicense, ApprovalLicense, GetApprovalList, GetApprovalListEmail, axiosErrorMessages } from "../../../API/api";
import { enqueueSnackbar } from "notistack";
import axios, { AxiosError } from "axios";
import { SorterResult } from "antd/es/table/interface";

interface ApprovalLists {
  licenseRequestId: 0,
  description: "string",
  doneBy: "string",
  taskDetails: []
}

const Approvals = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [showTaskDetails, setShowTaskDetails] = useState<boolean>(false)
  const [openRejectReason, setOpenRejectReason] = useState<boolean>(false)
  const [sortedInfo, setSortedInfo] = useState<SorterResult<any>>({});
  const [pagesize,setPageSize] = useState<number>(50)

  const [approvalList, setApprovalList] = useState<ApprovalLists[]>([])
  const [taskDetail, setTaskDetail] = useState([])
  const [licensingId, setLicensingId] = useState<number>(0)
  const [taskType,setTaskType] = useState<string>("");
  useEffect(() => {
   
    getApprovalListCombined()
  }, []);


const getApprovalListCombined = async () => {
  setIsLoading(true)
   // Use Promise.all to wait for both API calls to resolve
   const [emailResponse, approvalResponse] = await Promise.all([
    GetApprovalListEmail(),
    GetApprovalList()
  ]);

  const emailData = emailResponse.data.map((approvals:any) => ({
    ...approvals,
    type:'email',
    key: approvals.licenseRequestId,
  }));

  const approvalData = approvalResponse.data.map((approvals:any) => ({
    ...approvals,
    type:'software',
    key: approvals.licenseRequestId,
  }));

  // Combine or process the data as needed
  const combinedData = [...emailData, ...approvalData];
  setApprovalList(combinedData);
  setIsLoading(false)

}

  const onShowTaskDetails = (row: any) => {
    setShowTaskDetails(true)
    setTaskDetail(row)
  }
  const columns = [
    {
      title: "No",
      dataIndex: "id",
      key: "id",
      render: (text: any, record: any, index: number) =>
        (currentPage - 1) * pagesize + index + 1,
    },
    {
      title: "Task Description",
      dataIndex: "description",
      key: "description",
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: "Done By",
      dataIndex: "doneBy",
      key: "userRole",
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: "View Details",
      dataIndex: "doneBy",
      key: "userRole",
      render: (_: any, record: any) => <div> 
                          <Button style={{marginRight:'15px'}} type="link" onClick={() => onShowTaskDetails(record)}  icon={<EyeOutlined />} size="small" />

      </div>,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => {
        return (
          <>
            {" "}
            <Popconfirm
              title="Do you want to approve the task?"
              onConfirm={() => handleEdit(record)}
            >
              <Typography.Link >
                Approve
              </Typography.Link>
            </Popconfirm>
            <Popconfirm
              title="Do you want to reject the task?"
              onConfirm={() => handleReject(record)}
            >
              <Typography.Link className="delete-btn">
                Reject
              </Typography.Link>
            </Popconfirm>
          </>
        );
      },
    },
  ];
  const handleEdit = (rowData: any) => {
    const statusId = 2
    const comments = ""
    if(rowData.type === 'software') {
      setIsLoading(true)
      ApprovalLicense(rowData.licenseRequestId, statusId, comments)
      .then((response: any) => {
        enqueueSnackbar("Approved the Task", {
          variant: 'success', anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        })
        getApprovalListCombined();
      }).catch((error: any) => {
        let errorMsg;
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          errorMsg = axiosErrorMessages(axiosError);
        } else {
          errorMsg = error.message;
        }
        enqueueSnackbar(errorMsg, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setIsLoading(false)

      })
    }else   {
      ApprovalEmailLicense(rowData.licenseRequestId, statusId, comments)
      .then((response: any) => {
        enqueueSnackbar("Approved the Task", {
          variant: 'success', anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        })
        getApprovalListCombined();
      }).catch((error: any) => {
        let errorMsg;
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          errorMsg = axiosErrorMessages(axiosError);
        } else {
          errorMsg = error.message;
        }
        enqueueSnackbar(errorMsg, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setIsLoading(false)

      })
    }
   
  }
  const handleChange: TableProps<any>["onChange"] = (
  
    pagination,
    filters,
    sorter
  ) => {
    setSortedInfo(sorter as SorterResult<any>);
    setCurrentPage(pagination.current || 1);
    setPageSize(pagination.pageSize ?? 50)


  };
  const handleReject = (rowData: any) => {
    
    setTaskType(rowData.type)
    setOpenRejectReason(true)
    setLicensingId(rowData.licenseRequestId)
  }

  const handleClose = () => { setOpenRejectReason(false); getApprovalListCombined(); }


  return <>
    {" "}
    <AdminLayout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme: any) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div>
        <div className="employee-table-header ">
          <Row gutter={16} style={{ alignItems: "center", margin: "12px 16px" }}>
            <Col className="gutter-row" lg={12} sm={24}>
              <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                Approval List
              </h3>
            </Col>
            <Col className="gutter-row pm-search-flex" xl={{ span: 10, offset: 2 }} lg={24} xs={24} style={{ display: "flex" }}>


            </Col>
          </Row>
        </div>

        <Table
          sortDirections={customSortDirections}
          className="status-list-admin"
          columns={columns}
          tableLayout="auto"
          size='small'
          onChange={handleChange}

          pagination={{
            current: currentPage,
            showSizeChanger: true,
            defaultPageSize: 50,
          }}
          scroll={{ y: 500 }}

          rowClassName="editable-row"
          dataSource={approvalList}

        />
      </div>

      {showTaskDetails && <TaskDetails onClosePopup={() => setShowTaskDetails(false)} taskDetails={taskDetail} />}

      {openRejectReason && <RejectReason taskType={taskType} onClose={() => handleClose()} licensingId={licensingId} />}
    </AdminLayout>
  </>
}

export default Approvals;